// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

import themeConfig from "@/../siteThemeConfig.js";

const getters = {

	// COMPONENT
	// vx-autosuggest
	// starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
	anuncioFavorito: (state) => (identificacao) => {
		return state.favoritos.findIndex((item) => item == identificacao);
	},
	anunciosFavoritos: (state) => {
		return state.favoritos;
	},
	totalAnunciosFavoritos: (state) => {
		return state.favoritos.length;
	},
	windowBreakPoint: (state) => {

		// This should be same as tailwind. So, it stays in sync with tailwind utility classes
		if (state.windowWidth >= 1200) return "xl";
		else if (state.windowWidth >= 992) return "lg";
		else if (state.windowWidth >= 768) return "md";
		else if (state.windowWidth >= 576) return "sm";
		else return "xs";
	},
	isUserLoggedIn: (state) => {
		if (state.AppActiveUser &&
			state.AppActiveUser.uid &&
			state.AppActiveUser.contaToken &&
			state.AppActiveUser.userRole &&
			state.AppActiveUser.displayName &&
			localStorage.getItem(themeConfig.userInfoLocalStorageKey)
			/*&&
				 localStorage.getItem('accessToken') &&
				 localStorage.getItem('accessToken') == state.AppActiveUser.token*/
		) {
			//console.log('isUserLoggedIn', state.AppActiveUser.displayName, true);
			return true;
		}
		//console.log('isUserLoggedIn', state.AppActiveUser.displayName, false);
		return false;
	},
	routerIsBusy: (state) => {
		if (state.routerIsBusy) {
			return true;
		}
		return false;
	}
};

export default getters;
